<template>
  <div>
    <vxe-grid
      ref="table"
      row-id="custBizTeamSetCode"
      round
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @cell-click="cellClick"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displayLogo="{ row: { bigImageUrl } }">
        <div class="d-flex">
          <el-image
            :src="bigImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[bigImageUrl || '/image/static/img/nopic.jpg']"
            style="width: 90px;height: 90px;"
            fit="contain"
          />
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div>{{ row.custNo }}</div>
        <el-tag
          size="mini"
          :type="
            row.custStatus === 'N' || row.custStatus === 'B'
              ? 'danger'
              : row.custStatus === 'P'
              ? 'warning'
              : row.custStatus === 'P'
              ? 'success'
              : ''
          "
        >
          {{ row.v_custStatus }}
        </el-tag>
      </template>
      <template v-slot:displayName="{ row }">
        <div>{{ row.custShortName }}</div>
        <div>{{ row.custName }}</div>
      </template>
      <template v-slot:displayUser="{ row }">
        <div class="d-flex align-items-center">
          <el-avatar :src="row.memImgUrl" class="mr-2">U</el-avatar>
          <div>{{ row.userName }}</div>
        </div>
      </template>
      <template v-slot:displayModify="{ row }">
        <div>{{ row.modifyByName }}</div>
        <div>{{ row.modifyDate }}</div>
      </template>
      <template v-slot:displayCategory="{ row }">
        <div
          v-if="row.custCategoryNameList && !!row.custCategoryNameList.length"
        >
          <el-tag
            size="mini"
            class="mr-1"
            v-for="(category, index) in row.custCategoryNameList"
            :key="index"
          >
            {{ category }}
          </el-tag>
        </div>
      </template>
      <template v-slot:displayStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.custBizTeamSetStatus === 'N' ? 'danger' : 'success'"
        >
          {{ row.v_custBizTeamSetStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableOpts from './table-opts'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'displayLogo']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
    optCommand({ opt, row }) {
      const { menuType } = opt

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditFormDialog', { type: menuType, row })
          break
        case 'delete':
          this.del(row)
          break
      }
    },
    async del({ custBizTeamSetCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBizTeamSetDelApi({ custBizTeamSetCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
